import type { MachineState } from '../../api/types'
import { stateLabel } from '../../utils/format'

export function StatusPill({
  state,
  small = false,
  pulse = false,
  label,
}: {
  state: MachineState | string
  small?: boolean
  pulse?: boolean
  label?: string
}) {
  return (
    <span className={`status-pill status-${state} ${small ? 'status-pill--small' : ''}`}>
      <i className={pulse ? 'pulse' : ''} />
      {label ?? stateLabel[state as MachineState] ?? state}
    </span>
  )
}
